<template>

    <b-row>

        <b-col>

            <b-card
                header="Text Thread"
                header-text-variant="white"
                header-bg-variant="info">

                <div class="d-flex align-items-center justify-content-end">

                    <b-button variant="info" @click=" loadTable() ">Reload</b-button>
                </div>

                <b-row v-if=" items.length > 0 " class="mb-2">

                    <b-col class="d-flex justify-content-between align-items-center my-1">

                        <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " class="mb-0" />

                        <p class="mb-0">{{ paginationText }}</p>
                    </b-col>
                </b-row>

                <loading-card v-if=" loading "></loading-card>
                <h3 v-else-if=" !loading && items.length == 0 " class="text-center">-- No message history with this user --</h3>

                <b-row>

                    <b-col class="d-flex flex-column" sm="12" md="8" offset-md="2">

                        <div v-for=" text in items " :key=" text.id " :class=" bubbleClasses( text ) ">

                            <div class="small font-bold d-flex align-items-center justify-content-between">

                                <p class="mb-0">{{ formatDateTime( text.created_at ) }}</p>
                                <p class="mb-0">{{ text.direction == 'outgoing' ? 'From CareExchange' : `From ${text.recipient}` }}</p>
                            </div>

                            <div class="small font-bold mb-2">{{ phoneFormat( text.from_number ) }}:</div>

                            <div class="mb-1">{{ text.body }}</div>

                        </div>
                    </b-col>
                </b-row>
                <b-row v-if=" items.length > 0 ">

                    <b-col class="d-flex justify-content-between align-items-center my-1">

                        <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " class="mb-0" />

                        <p class="mb-0">{{ paginationText }}</p>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import PaginatedTable from '../../mixins/PaginatedTable';
    import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';
    import UsesRole from '../../mixins/UsesRole';

    export default {

        mixins : [ PaginatedTable, FormatsDates, FormatsNumbers, UsesRole ],
        props: {

            textmessage : {

                type     : Object,
                default  : null,
                required : false
            },
            userId : {

                type     : Number,
                default  : null,
                required : false
            }
        },
        data(){

            return {

                perPage : 10
            }
        },
        computed: {

            unwatchedFilters(){ return `&user_id=${this.userId}`; },
            baseUrl(){ return `/${this.controller}/text_message`; }
        },
        methods: {

            bubbleClasses( text ){

                const base = [ 'text-bubble', 'mb-3', 'p-2' ];
                base.push( ( text.direction == 'incoming' ? 'blue-background' : 'green-background' ) );
                base.push( ( text.direction == 'incoming' ? 'align-self-start' : 'align-self-end' ) );
                return base.join( ' ' );
            }
        },
    }
</script>

<style scoped>

    .blue-background {

        background-color: lightblue;
        box-shadow: 0px 2px 3px 0px rgba(173, 216, 230, 0.6);
    }
    .green-background {

        background-color: lightgreen;
        box-shadow: 0px 2px 3px 0px rgba(144, 238, 144, 0.6);
    }
    .text-bubble {

        border-radius: 5px;
        width: 450px;
    }
</style>